/**
 * 角色权限控制组件 License By http://eleadmin.com
 */
import Vue from "vue"
import {is_Empty, hasPermission, hasRole} from "./utils";

export default {
    install(app) {
        // 添加自定义指令
        app.directive('role', {
            bind: (el, binding,) => {
                Vue.nextTick(() => {
                    if (hasRole(binding.value)) {
                        el.parentNode.removeChild(el);
                    }
                });
            }
        });
        app.directive('permission', {
            bind: (el, binding) => {
                Vue.nextTick(() => {
                    if (hasPermission(binding.value)) {
                        el.parentNode.removeChild(el);
                    }
                });
            }
        });
    },
}



// WEBPACK FOOTER //
// ./src/utils/permission.js